import { useQuery } from '@tanstack/react-query';
import {
  fetchOwnerSummary,
  fetchOccupancy,
  fetchPayouts,
  type OwnerSummaryQuery,
} from '@/services/api/owner.api';

export function useOwnerSummary(query?: OwnerSummaryQuery, enabled = true) {
  return useQuery({
    queryKey: ['owner', 'summary', query],
    queryFn: () => fetchOwnerSummary(query),
    staleTime: 30_000,
    enabled,
    retry: false,
  });
}

export function useOccupancy() {
  return useQuery({
    queryKey: ['owner', 'occupancy'],
    queryFn: () => fetchOccupancy(),
    staleTime: 30_000,
  });
}

export function usePayouts(enabled = true) {
  return useQuery({
    queryKey: ['owner', 'payouts'],
    queryFn: () => fetchPayouts(),
    staleTime: 30_000,
    enabled,
    retry: false,
  });
}
